module.exports = __webpack_public_path__ + "4e32a6afce7b0cf070aa1cea5687b49d.MP3";